module.exports = __webpack_public_path__ + "static/media/nice_shaysh_bg.3bc39a5d.jpg";